import { redirect } from 'react-router-dom';
import { ErrorBoundary } from '~/components/ErrorBoundary/ErrorBoundary';
import { BaseContainer } from '~/layouts/BaseContainer';
import { routePath } from '~/utils/constants';
import { isWeb } from '~/utils/helper/device';

export const route = [
  {
    path: routePath.home,
    loader: () => {
      return isWeb ? redirect(routePath.resource) : redirect(routePath.file);
    },
    errorElement: <ErrorBoundary />,
  },
  {
    path: routePath.file,
    loader: () => {
      return isWeb ? redirect(routePath.resource) : null;
    },
    element: <BaseContainer />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: routePath.resource,
    element: <BaseContainer />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: routePath.history,
    loader: () => {
      return isWeb ? redirect(routePath.resource) : null;
    },
    element: <BaseContainer />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: routePath.login,
    element: <BaseContainer />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: routePath.admin,
    element: <BaseContainer />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: routePath.adminLogin,
    element: <BaseContainer />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: routePath.latestNews,
    element: <BaseContainer />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: '*',
    loader: () => {
      return redirect(routePath.resource);
    },
    errorElement: <ErrorBoundary />,
  },
];
